import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";

const ReceivingComplaint = (params) => {
  console.log("inn:", params);
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ReceivingComplaint",
    params
  );
};

const GetAllSubDistrictAutocomplete = () => {
  return axiosGet(
    appsettings.digtalIdAPIUrl +
      "api/AddressUtils/GetAllSubDistrictAutocomplete"
  );
};

const GetAddressBySubDistrictName = (params) => {
  return axiosGet(
    appsettings.digtalIdAPIUrl +
      "api/AddressUtils/GetAddressBySubDistrictName?subDistrictName=" +
      params
  );
};

const GetValidateTumbolName = (params) => {
  return axiosGet(
    appsettings.digtalIdAPIUrl +
      "api/AddressUtils/GetValidateTumbolName?subDistrictName=" +
      params
  );
};

const getbyidentity = (params) => {
    if(params)
    {
        return axiosGet(
        appsettings.digtalIdAPIUrl +
            "api/customer/getbyidentity?identity=" +
            params
        );
    }
  };

const GetInitComplaintTmMasterType = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Complaint/GetInitComplaintTmMasterType",params
  );
};

const GetComplaintList = (complaintGuid) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/GetComplaintList?complaintGuid="+complaintGuid
  );
};

// const GetComplaintList = (complaintGuid, isGroupGuid = false) => {
//   return axiosGet(
//     appsettings.ocpbComplaintAPIUrl + "api/Complaint/GetComplaintList?complaintGuid="+complaintGuid+"&isGroupGuid="+isGroupGuid
//   );
// };


const GetComplaintTmMaster = (masterTypeId, masterId) => {
  var initSymbol = "?";
  var url =
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/GetComplaintTmMaster";

  if (masterTypeId) {
    url = url + initSymbol + "masterTypeId=" + masterTypeId;
    initSymbol = "&";
  }
  if (masterId) {
    url = url + initSymbol + "masterId=" + masterId;
    initSymbol = "&";
  }

  return axiosGet(url);
};

const updateComplaintProcess = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/UpdateComplaintProcess",
    params
  );
};

const updateComplaintProcessNoDoc = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/UpdateComplaintProcess_No_Doc",
    params
  );
};

const updateReadDate = (complaintId, departmentId, userId, mode) => {
  const params = {
    complaintId, departmentId, userId, mode
  }
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ComplaintRead",
    params
  );
}

const GetMasterTypeAll = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/GetMasterTypeAll",
    params
  );
};

const getComplaintById = (id) => {
  const params = {
    id,
  };
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/GetById",
    params
  );
};

const updateComplaint = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/UpdateComplaint",
    params
  );
};

const getComplaintForAttachment = (params) => {
  return axiosGet(appsettings.ocpbComplaintAPIUrl + 'api/Complaint/ComplaintForAttachment', params)
}

const getComplaintCancelList = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ComplaintCancelList",
    params,
  );
}

const getAIMaster = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/AIMaster",
    params
  );
};

const getSimilarComplaint = (id) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/GetSimilarComplaint?complaintId=" + id,
  );
};

export {
  ReceivingComplaint,
  GetAllSubDistrictAutocomplete,
  updateComplaintProcess,
  updateComplaintProcessNoDoc,
  updateReadDate,
  GetAddressBySubDistrictName,
  GetValidateTumbolName,
  getComplaintById,
  GetInitComplaintTmMasterType,
  GetComplaintTmMaster,
  updateComplaint,
  getbyidentity,
  GetMasterTypeAll,
  GetComplaintList,
  getComplaintForAttachment,
  getComplaintCancelList,
  getAIMaster,
  getSimilarComplaint,
};
